// extracted by mini-css-extract-plugin
export default {"example-slide":"styles__example-slide--eJtaU","next-arrow":"styles__next-arrow--Fz9Pi","back-arrow":"styles__back-arrow--LGoWb","disabled":"styles__disabled--D9fER"};